export function TimerRemove({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9238 8.67383C15.7688 8.67383 16.4618 9.35837 16.4619 10.2119C16.4619 11.057 15.7775 11.75 14.9238 11.75H11.5C11.0858 11.75 10.75 12.0858 10.75 12.5C10.75 12.9142 11.0858 13.25 11.5 13.25H14.9238C16.6123 13.25 17.9619 11.879 17.9619 10.2119C17.9618 8.52364 16.5909 7.17383 14.9238 7.17383H12.5391L13.1777 5.25H17.2119L17.2891 5.24609C17.6671 5.20755 17.9619 4.88823 17.9619 4.5C17.9619 4.11177 17.6671 3.79245 17.2891 3.75391L17.2119 3.75H12.6367C12.354 3.75 12.0982 3.90825 11.9707 4.15332L11.9248 4.26367L10.7881 7.68848C10.7124 7.91698 10.7507 8.16807 10.8916 8.36328C11.0326 8.55862 11.2591 8.67383 11.5 8.67383H14.9238ZM8.25 8.5C8.25 8.08579 7.91421 7.75 7.5 7.75H1.5C1.08579 7.75 0.75 8.08579 0.75 8.5C0.75 8.91421 1.08579 9.25 1.5 9.25H7.5C7.91421 9.25 8.25 8.91421 8.25 8.5Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
